import type { PiletApi } from '@chess/platform-web';
import { STORAGE_API, type Storage } from '@chess/api-storage';
import { GAMES_API } from '@chess/api-games';
import { MemoryGames } from '@chess/api-games/memory';

// Provides `games` over the app's storage: a game is a folder under
// `games/<id>` with `game.json`, `game.pgn` and one subfolder per plugin.
// The api package's storage-backed implementation lays games out exactly
// that way, so over the real storage it is the real provider.
export function setup(app: PiletApi) {
  app.getApi<Storage>(STORAGE_API).then((storage) => {
    app.registerApi(GAMES_API, new MemoryGames(storage));
  });
}
